import {ResponseError, type ImpersonateResult} from "../api_client";
import {BasePathUrl} from "../appsettings";


export const IMPERSONATION_FEATURE_TOGGLE = {
    endImpersonation: false,
    impersonation: false
};
/**
 * POST /Account/Impersonate/{impUserId}?redirectUrl=
 * Cookie-сессия (credentials: same-origin). Сгенерированный клиент не передаёт redirectUrl.
 */
export const postImpersonate = async (
  impUserId: string,
  redirectUrl: string
): Promise<ImpersonateResult> => {
  const url = new URL(
    `${BasePathUrl}/Account/Impersonate/${encodeURIComponent(impUserId)}`,
    globalThis.location.origin
  );
  url.searchParams.set("redirectUrl", redirectUrl);

  const response = await fetch(url.toString(), {
    method: "POST",
    credentials: "same-origin"
  });

  if (!response.ok) {
    throw new ResponseError(response, "Response returned an error code");
  }

  return (await response.json()) as ImpersonateResult;
};

/**
 * POST /Account/Impersonate/Logout/{clientId}
 * Cookie-сессия (credentials: same-origin).
 */
export const postImpersonateLogout = async (
  clientId: string
): Promise<ImpersonateResult> => {
  const url = new URL(
    `${BasePathUrl}/Account/Impersonate/Logout/${encodeURIComponent(clientId)}`,
    globalThis.location.origin
  );

  const response = await fetch(url.toString(), {
    method: "POST",
    credentials: "same-origin"
  });

  if (!response.ok) {
    throw new ResponseError(response, "Response returned an error code");
  }

  return (await response.json()) as ImpersonateResult;
};

/** Нормализует redirect из Impersonate/Logout: ~/ и пустое → /. */
export const normalizeLogoutRedirectUrl = (redirectUrl?: string | null): string => {
  if (!redirectUrl || redirectUrl === "~/" || redirectUrl.trim() === "") {
    return "/";
  }
  return redirectUrl;
};
